export default "__VITE_ASSET__05af29f6__"